import React, {useState} from "react";

import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

import EmptyData from "@/components/EmptyData";

import "./index.scss";

// Tabella base. columns: [{key, label, align, render(row), sortValue(row) | sortable}], rowKey(row) facoltativo
// Su telefono ogni riga diventa una scheda con etichetta e valore.
export default function DataTable({columns, rows, onRowClick, empty, rowKey}) {
	const [sort, setSort] = useState({key: null, desc: false});

	if (!rows?.length) return <EmptyData>{empty}</EmptyData>;

	const sortColumn = columns.find((c) => c.key === sort.key);
	const valueOf = (row) =>
		sortColumn.sortValue ? sortColumn.sortValue(row) : row[sortColumn.key];
	const sorted = sortColumn
		? [...rows].sort((a, b) => {
				const va = valueOf(a);
				const vb = valueOf(b);
				if (va == null) return 1;
				if (vb == null) return -1;
				const cmp =
					typeof va === "number" && typeof vb === "number"
						? va - vb
						: String(va).localeCompare(String(vb), "it");
				return sort.desc ? -cmp : cmp;
			})
		: rows;

	const toggleSort = (key) =>
		setSort((s) => ({key, desc: s.key === key ? !s.desc : false}));

	return (
		<div className="data-table-wrap">
			<table className="data-table">
				<thead>
					<tr>
						{columns.map((c) => {
							const sortable = c.sortable || c.sortValue;
							return (
								<th
									key={c.key}
									className={
										(c.align ? "is-" + c.align : "") +
										(sortable ? " is-sortable" : "")
									}
									onClick={sortable ? () => toggleSort(c.key) : undefined}
								>
									{c.label}
									{sort.key === c.key &&
										(sort.desc ? (
											<ArrowDownwardIcon className="data-table__sort" />
										) : (
											<ArrowUpwardIcon className="data-table__sort" />
										))}
								</th>
							);
						})}
					</tr>
				</thead>
				<tbody>
					{sorted.map((row, i) => (
						<tr
							key={rowKey ? rowKey(row) : row.id ?? i}
							className={onRowClick ? "is-clickable" : ""}
							onClick={onRowClick ? () => onRowClick(row) : undefined}
						>
							{columns.map((c) => (
								<td
									key={c.key}
									data-label={c.label}
									className={c.align ? "is-" + c.align : ""}
								>
									{c.render ? c.render(row) : row[c.key]}
								</td>
							))}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
}
